import { SignIn } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";

// The one public route (TASK.md "apps/admin surface contract") — the pinger's probe. The token
// colors/radius/font/motion live once on <ClerkProvider> (src/lib/clerk-appearance.ts) and reach
// every Clerk component including this one — a block never ships as-downloaded (STACK.md), the
// same discipline applied to the shadcnblocks theme. Only what's unique to THIS component
// (its card chrome, hiding the sign-up footer action — Restricted mode makes it dead) lives here.
export const Route = createFileRoute("/sign-in")({
  component: SignInPage,
});

function SignInPage() {
  return (
    // A real <main> landmark, not a bare div: axe's landmark-one-main and region rules both
    // require every rendered node to sit inside a landmark — this route's entire content is
    // the sign-in form, so it IS the page's main content.
    <main className="flex min-h-svh items-center justify-center bg-background px-4">
      <SignIn
        appearance={{
          elements: {
            card: "shadow-sm ring-1 ring-foreground/10",
            footerAction: "hidden",
          },
        }}
      />
    </main>
  );
}
